import ErrorImg from '../../../assets/dead_link_setup.svg?react';
import { getPortalUrl } from '../../../utils/utils';

const LinkDeadErrorView = () => {
  const portalLink = getPortalUrl();
  return (
    <div className={'error-view-container'}>
      <ErrorImg />
      <h3 style={{ color: 'inherit' }}>Initial configuration has already been completed</h3>
      <div>
        Go to <a href={portalLink}>{window.location.host}</a> to log in
      </div>
    </div>
  );
};

export { LinkDeadErrorView };
